export default __webpack_public_path__ + "static/Guy-in-cafe-on-internet-fastest-wifi-hero-image-964ea07fad8f1e48c50e6f9c952539e7.jpg";